<template>
  <div class="borderConfig chartConfig_viewDP">
    <div class="chartDivConfig checkViewConfig">
      <el-checkbox v-model="config.zdy.chartsTask1" @change="getRender">是否开启定时动画</el-checkbox>
    </div>

    <div class="chartDivConfig numViewConfig numViewConfig_unit" v-if="config.zdy.chartsTask1==true">
      <span class="span_til">更新频率</span>
      <el-input v-model="config.zdy.chartsUpdateFrequency1" @change="getRender" type="number" min="0"></el-input>
      <div class="unit">s</div>
    </div>
    <div class="chartDivConfig numViewConfig numViewConfig_unit" v-if="config.zdy.chartsTask1==true">
      <span class="span_til">动画时长</span>
      <el-input v-model="config.zdy.chartsAnimationDuration" @change="getRender" type="number" min="0"></el-input>
      <div class="unit">s</div>
    </div>

    <div class="chartDivConfig checkViewConfig">
      <el-checkbox v-model="config.zdy.chartsTask2" @change="getRender">是否开启数据定时更新</el-checkbox>
    </div>

    <div class="chartDivConfig numViewConfig numViewConfig_unit" v-if="config.zdy.chartsTask2==true">
      <span class="span_til">更新频率</span>
      <el-input v-model="config.zdy.chartsUpdateFrequency2" @change="getRender" type="number" min="0"></el-input>
      <div class="unit">s</div>
    </div>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/5/25 4:01 下午
 */

export default {
  name: 'borderConfig',
  components: {},
  props: {},
  computed: {//这个是监听
    config() {
      return this.$store.state.designer.chart.comConfig;
    },
  },
  created(){
  },
  data() {
    return {
      chartsTask1: false,//是否开启定时动画
      chartsUpdateFrequency1: 0,//更新频率1
      chartsUpdateFrequency2: 0,//更新频率2
      chartsAnimationDuration: 0,//动画时长
      chartsTask2: false,
    }
  },
  methods: {
    getRender() {
      this.$store.dispatch('screenRender');
    },
  },
  mounted() {
  },
  destroyed() {

  }
}
</script>

<style lang="less">
.borderConfig {
  .minInput {
    > span {
      width: 40px;
    }

    > .el-input {
      width: 50%;
    }

    > .el-select {
      width: 50%;
    }
  }
}
</style>